import React from 'react';
import autoBind from 'react-autobind';
import _ from 'lodash';
import {userTypes, downloadId, formGroups} from '../../constants/CongratulationsConstants';
import {UserTypes, ProductIds} from '../../constants/ApplicationConstants';
import FormList from './FormList.jsx';
import {addClickCallbackToLink, removeClickCallback, formatString} from '../../utils/Formatter';

export default class ReadyForFunding extends React.Component {
    constructor(props) {
        super(props);
        autoBind(this);
    }

    accountConfirmationForm(){
        return(<p dangerouslySetInnerHTML={{__html: this.props.content.accountConfirmationCopy}}></p>);
    }

    getMultipleFormMessage(item){
        let message = '';
        if (!item){
            return message;
        }
        let value = item.value.split('__');
        if (value && value.length > 0 && value[0]){
            message = this.props.content[this.props.productCode].formList[value[0]];
        }

        return message;
    }

    ePost(){
        let message = '';
        if (this.props.userType === UserTypes.INVESTOR){
            message = this.props.content.ePostFniCopy;
        }
        else if(this.props.userType === UserTypes.ADVISER){
            message = this.props.content.ePostFnaCopy;
        }

        if (message){
            return (<p dangerouslySetInnerHTML={{__html: message}}></p>);
        }
    }

    applicationForm(){
        let message = '';
        return (<div className="spacing__bottom-12px">
                {this.props.data.applicationFormList.map(function(item, idx){
                    if (item.name){
                        let index = item.value.split('__');
                        message = formatString(this.getMultipleFormMessage(item), {idx: `__${index[1]}`, name: ' - ' + item.name});
                    }
                    else{
                        message = formatString(this.props.content[this.props.productCode].formList[item.value], {name: ''});
                    }
                    return(<div key={`appForm__${idx}`} dangerouslySetInnerHTML={{__html: message}}></div>);
                 }.bind(this))}
                <br/><p>{this.props.content.applicationFormCopy}</p>
            </div>);
    }

    formList(){
        let group;
        if (this.props.productCode !== ProductIds.INVESTMENT){
            group = formGroups;
        }
        return <FormList formList={this.props.data.formList}
                         groups={group}
                         downloadFileCallBack={this.download}
                         content={this.props.content[this.props.productCode].formList} />
    }

    render() {
        if (!this.props.content[this.props.productCode]){
            return null;
        }
        return (
            <div className="container">
                {this.accountConfirmationForm()}
                {this.applicationForm()}
                {this.formList()}
                {this.ePost()}
            </div>);
    }

    download(e){
        if (this.props.downloadFileCallBack){
            this.props.downloadFileCallBack(e.target.id);
        }
    }

    componentDidMount(){
        addClickCallbackToLink(downloadId.accountConfirmation, this.download);
        _.forEach(this.props.data.applicationFormList, function(item){
            addClickCallbackToLink(item.value, this.download)
        }.bind(this));
    }

    componentWillUnmount(){
        removeClickCallback(downloadId.accountConfirmation, this.download);
        _.forEach(this.props.data.applicationFormList, function(item){
            removeClickCallback(item.value, this.download)
        }.bind(this));
    }
}

ReadyForFunding.propTypes = {
    data: React.PropTypes.object.isRequired,
    content: React.PropTypes.object.isRequired,
    userType: React.PropTypes.oneOf(userTypes),
    productCode: React.PropTypes.number.isRequired,
    downloadFileCallBack: React.PropTypes.func
};



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/Congratulations/ReadyForFunding.jsx